<template>
  	<div class="current-font">
      <brand-menu></brand-menu>
      <b-container fluid>
        <div class="d-flex justify-content-center" style="margin-bottom: -40px;">
          <div>
            <img :src="imgSrc[params.type]" alt="">
          </div>
        </div>
        <checkout-header title="Payment">
          <div>
            {{ params.title }}
          </div>
        </checkout-header>
        <div class="d-flex justify-content-center">
          <div class="link" @click="handleLink">{{ params.link }}</div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="next">
            <b-button variant="dark" block @click="handleNext">{{ params.next }}</b-button>
          </div>
        </div>
      </b-container>
    </div>
</template>

<script>
import BrandMenu from "@/components/BrandMenu";
import CheckoutHeader from "@/components/CheckoutHeader";
export default {
  name: "ResultView",
  components: {
    BrandMenu,
    CheckoutHeader
  },
  data() {
    return {
      imgSrc: {
        success: require('@/assets/xh/images/check_ring_round.png'),
        fail: require('@/assets/xh/images/close_ring.png'),
      },
      params: {
        type: 'success',
        title: 'Success',
        link: '',
        linkUrl: '',
        next: 'BACK',
        nextUrl: '',
      }
    }

  },
  created() {
    console.log(this.$route.params)
    if (this.$route.params && Object.keys(this.$route.params).length > 0) {
      this.params = this.$route.params;
    }
  },
  methods: {
    handleLink(event) {
      if (this.params.linkUrl) {
        this.$router.push(this.params.linkUrl)
      }
    },
    handleNext(event) {
      if (this.params.nextUrl) {
        this.$router.push(this.params.nextUrl)
      } else {
        this.$router.back(-1)
      }
    }
  }
}
</script>

<style scoped>
  .current-font {
    font-family: SourceHanSansCN-ExtraLight;
    font-weight: 250;
    font-size: 18px;
  }

  .link {
    margin: 3.6rem 0 1rem 0;
    text-decoration: underline;
    cursor: pointer;
  }

  .next {
    width: 332px;
    margin-bottom: 36rem;
  }

  .btn {
    font-family: SourceHanSansCN-ExtraLight;
  	font-size: 18px;
    font-weight: 250;
    background-color: black;
  }
</style>



// WEBPACK FOOTER //
// src/views/ResultView.vue